import React from 'react'
import Translation from '../Translation/cont/Translation'

class DashboardStats extends React.Component {
    render() {
        const {
            currentWeek,
            currentDate,
            currentMoviesCount,
            futureMoviesCount,
            noPerformancesCount,
            performancesCount,
            incompleteMovies,
            version,
            openPanel,
            onTogglePanel,
        } = this.props

        const incompleteCount = incompleteMovies ? incompleteMovies.length : 0

        return (
            <div className="db-stat-strip">
                <div
                    className={`db-stat-card${currentMoviesCount > 0 ? ' db-stat-card--toggle' : ''}${openPanel === 'currentMovies' ? ' db-stat-card--open' : ''}`}
                    onClick={currentMoviesCount > 0 ? () => onTogglePanel('currentMovies') : undefined}
                >
                    <div className="db-sc-lbl text-small-bold"><Translation id="section_filter_current_movies"/></div>
                    <div className="db-sc-val title-xlarge-bold">{currentMoviesCount}</div>
                    <div className="db-sc-sub text-xxssmall-light"><Translation id="dashboard_stat_current_movies_sub"/></div>
                    {currentMoviesCount > 0 && (
                        <span className="db-sc-toggle text-xsmall-light">
                            {openPanel === 'currentMovies'
                                ? <Translation id="button_close" before="▲ "/>
                                : <Translation id="dashboard_stat_show_list" before="▼ "/>}
                        </span>
                    )}
                </div>

                <div
                    className={`db-stat-card${futureMoviesCount > 0 ? ' db-stat-card--toggle' : ''}${openPanel === 'future' ? ' db-stat-card--open' : ''}`}
                    onClick={futureMoviesCount > 0 ? () => onTogglePanel('future') : undefined}
                >
                    <div className="db-sc-lbl text-small-bold"><Translation id="dashboard_stat_future_movies_label"/></div>
                    <div className="db-sc-val title-xlarge-bold">{futureMoviesCount}</div>
                    <div className="db-sc-sub text-xxssmall-light"><Translation id="dashboard_stat_future_movies_sub"/></div>
                    {futureMoviesCount > 0 && (
                        <span className="db-sc-toggle text-xsmall-light">
                            {openPanel === 'future'
                                ? <Translation id="button_close" before="▲ "/>
                                : <Translation id="dashboard_stat_show_list" before="▼ "/>}
                        </span>
                    )}
                </div>

                <div
                    className={`db-stat-card${noPerformancesCount > 0 ? ' db-stat-card--toggle' : ''}${openPanel === 'noPerformances' ? ' db-stat-card--open' : ''}`}
                    onClick={noPerformancesCount > 0 ? () => onTogglePanel('noPerformances') : undefined}
                >
                    <div className="db-sc-lbl text-small-bold"><Translation id="dashboard_stat_no_performances_label"/></div>
                    <div className="db-sc-val title-xlarge-bold">{noPerformancesCount}</div>
                    <div className="db-sc-sub text-xxssmall-light"><Translation id="dashboard_stat_no_performances_sub"/></div>
                    {noPerformancesCount > 0 && (
                        <span className="db-sc-toggle text-xsmall-light">
                            {openPanel === 'noPerformances'
                                ? <Translation id="button_close" before="▲ "/>
                                : <Translation id="dashboard_stat_show_list" before="▼ "/>}
                        </span>
                    )}
                </div>

                <div className="db-stat-card">
                    <div className="db-sc-lbl text-small-bold"><Translation id="dashboard_stat_performances_label"/></div>
                    <div className="db-sc-val title-xlarge-bold">{performancesCount}</div>
                    <div className="db-sc-sub text-xxssmall-light"><Translation id="dashboard_stat_performances_sub"/></div>
                </div>

                <div
                    className={`db-stat-card db-stat-card--warn${incompleteCount > 0 ? '' : ' db-stat-card--empty'}${openPanel === 'incompleteMovies' ? ' db-stat-card--open' : ''}`}
                    onClick={incompleteCount > 0 ? () => onTogglePanel('incompleteMovies') : undefined}
                >
                    <div className="db-sc-lbl text-small-bold"><Translation id="dashboard_stat_incomplete_movies_label"/></div>
                    <div className="db-sc-val db-sc-val--warn title-xlarge-bold">{incompleteCount}</div>
                    <div className="db-sc-sub text-xxssmall-light"><Translation id="dashboard_stat_incomplete_movies_sub"/></div>
                    {incompleteCount > 0 && (
                        <span className="db-sc-toggle db-sc-toggle--warn text-xsmall-light">
                            {openPanel === 'incompleteMovies'
                                ? <Translation id="button_close" before="▲ "/>
                                : <Translation id="dashboard_stat_show_list" before="▼ "/>}
                        </span>
                    )}
                </div>

                <div className="db-stat-card">
                    <div className="db-sc-lbl text-small-bold"><Translation id="dashboard_stat_current_week_label"/></div>
                    <div className="db-sc-val title-xlarge-bold">{currentWeek}</div>
                    <div className="db-sc-sub text-xxssmall-light">{currentDate && currentDate.split(' · ')[0]}</div>
                </div>

                <div className="db-stat-card">
                    <div className="db-sc-lbl text-small-bold"><Translation id="dashboard_stat_version_label"/></div>
                    <div className="db-sc-val db-sc-val--version title-xlarge-bold">{version}</div>
                </div>
            </div>
        )
    }
}

export default DashboardStats
